import { Injectable } from '@angular/core';
import { Discord } from './custom-social-links/custom-social-links-profiles/discord';
import { Other } from './custom-social-links/custom-social-links-profiles/other';
import { Website } from './custom-social-links/custom-social-links-profiles/website';
import { WeChat } from './custom-social-links/custom-social-links-profiles/wechat';
import { WhatsApp } from './custom-social-links/custom-social-links-profiles/whats-app';
import { ParseSocialResult } from './ParseSocialResult';
import { SocialLinksAdaptor } from './social-links-adaptor';

@Injectable({
  providedIn: 'root'
})
export class ParseSocialService {
  private socialLinksAdaptor = new SocialLinksAdaptor();
  /**
   *
   */
  constructor() {
    this.socialLinksAdaptor.addCustomProfile(WhatsApp);
    this.socialLinksAdaptor.addCustomProfile(WeChat);
    this.socialLinksAdaptor.addCustomProfile(Discord);
    this.socialLinksAdaptor.addCustomProfile(Website);
    this.socialLinksAdaptor.addCustomProfile(Other);
  }

  parseSocial(profile: string, input: string): ParseSocialResult {
    if (profile === 'twitter') {
      input = input.replace('x.com', 'twitter.com');
    }

    const result = this.socialLinksAdaptor.parseSocial(profile, input);

    return result;
  }
}
